<template>
  <div id="app">
      <header>
            <h2>
                <router-link to="/"><img src="./assets/images/logo.svg" alt=""></router-link>
            </h2>
            <nav v-if="loggedIn">
                <router-link to="/dashboard">{{currentUser.firstName}} {{currentUser.lastName}}</router-link>
                <router-link to="/management" v-if="isManager || isAdmin">Management</router-link>
                <a class="uk-icon-link" uk-icon="sign-out" @click.prevent="logOut"> </a>
            </nav>
            <nav v-else>
                <router-link to="/login">Log In</router-link>
                <router-link to="/register">Register</router-link>
            </nav>
      </header>
      <main>
            <div v-if="$route.name === 'login' || $route.name === 'register' || $route.name === 'reset-password' || $route.name === 'reset-password-form'" class="bg"></div>
            <h1 class="uk-text-center main-title" v-if="$route.name === 'main'">Genius Blueprint Assessment</h1>
            <section>
                <router-view></router-view>
            </section>
      </main>
      <footer>
          <div class="uk-child-width-expand@s uk-text-center" uk-grid>
            <div class="uk-width-auto row">
                <img src="./assets/images/logo_footer.svg" alt="">
            </div>
            <div class="row">
                <a href="https://www.leap2genius.com/genius-method/" target="_blank">The Genius Method</a>
                <a href="https://www.leap2genius.com/faq/" target="_blank">FAQ</a>
            </div>
            <div class="row">
                <a href="https://www.leap2genius.com/contact-us/">Contact us</a>
                <a href="https://www.leap2genius.com/privacy-policy/" target="_blank">Privacy Policy</a>
            </div>
            <div class="row">
                <a href="https://www.leap2genius.com/genius-blueprint-assessment/" target="_blank">Genius Blueprint Assessment</a>
                <a href="https://www.leap2genius.com/success/" target="_blank">How it works</a>
            </div>
          </div>
          <p class="uk-margin-top">&copy; {{year}} Leap2Genius. All right reserved | Teams and Conditions</p>
      </footer>
  </div>
</template>

<script>
export default {
    name: 'App',
    data() {
        return {
            year: new Date().getFullYear()
        }
    },
    computed: {
        loggedIn() {
           return this.$store.state.auth.status.loggedIn;
        },
        currentUser() {
            return this.$store.state.auth.user;
        },
        isManager() {
           if (this.currentUser && this.currentUser.roles) {
                return this.currentUser.roles.includes('manager');
            }
            return false;
        },
        isAdmin() {
           if (this.currentUser && this.currentUser.roles) {
                return this.currentUser.roles.includes('admin');
            }
            return false;
        },
        
    },
    methods: {
        logOut() {
            this.$store.dispatch('auth/logout');
            this.$router.push('/login');
        }
    },
}
</script>

<style>
@import "../node_modules/uikit/dist/css/uikit.min.css";
@import './assets/css/style.css';
</style>